var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestedMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F5FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21C26.2091 21 28 19.2091 28 17C28 14.7909 26.2091 13 24 13C21.7909 13 20 14.7909 20 17C20 19.2091 21.7909 21 24 21Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16V18",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29H29L28 35H20L19 29Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26C16.5414 26.0005 15.1331 25.4669 14.041 24.5C14.9063 23.7362 15.9737 23.2385 17.115 23.0668C18.2563 22.895 19.423 23.0564 20.4747 23.5317C21.5265 24.0069 22.4187 24.7757 23.0441 25.7458C23.6694 26.7159 24.0014 27.8459 24 29",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26C31.4586 26.0005 32.8669 25.4669 33.959 24.5C33.0937 23.7362 32.0263 23.2385 30.885 23.0668C29.7437 22.895 28.577 23.0564 27.5253 23.5317C26.4735 24.0069 25.5813 24.7757 24.956 25.7458C24.3306 26.7159 23.9987 27.8459 24 29",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestedMoney);
export default __webpack_public_path__ + "static/media/invested-money.a6d031e2df92b0921e4c74a288b16b4b.svg";
export { ForwardRef as ReactComponent };